const billInput = document.querySelector(".bill__input");
const billBtn = document.querySelector(".bill__btn__input");
const numOfPeopleInput = document.querySelector(".num__of__people__input");
const tipBtn = document.querySelectorAll(".percent-btn");
const tipAmount = document.querySelector("#tipAmount");
const personTotal = document.querySelector("#personTotal");
const btnContainer = document.querySelector(".btn__container");
const resetBtn = document.querySelector(".reset__button");
const customBtn = document.querySelector(".custom-btn");
const errorMessage = document.querySelector(".error-message");
const percentBtnContainer = document.querySelector(
  ".button__select__container"
);

const percentArr = [0.05, 0.1, 0.15, 0.25, 0.5];

const billArr = [];
const numArr = [];
const selectedTip = [0.05];
/////////////////////////////////////////////////////////////////
//Select Tip button
percentBtnContainer.addEventListener("click", function (e) {
  e.preventDefault();
  const clicked = e.target.closest(".percent-btn");

  //Guard clause
  if (!clicked) return;

  //entered bill amount
  const amount = Number(billInput.value);

  //set to total bill amount to empty array
  billArr.push(amount);

  //set Number of people value to empty array
  const numAmount = Number(numOfPeopleInput.value);
  numArr.push(numAmount);

  const dataSetTab = parseFloat(clicked.dataset.tab);
  const customValue = parseFloat(customBtn.value * 0.01);

  for (const [percent, i] of percentArr.entries())
    if (percent === dataSetTab) selectedTip.push(i);

  if (dataSetTab === 5) selectedTip.push(customValue);

  //Tip
  //get last element of array, which last tab selected convert to number
  const tipChoice = parseFloat(selectedTip.slice(-1));

  console.log(tipChoice);

  //Bill Amount
  //get last number of array convert to string
  const amountChoice = parseFloat(billArr.slice(-1));

  const peopleChoice = parseFloat(numArr.slice(-1));

  if (peopleChoice <= 0) {
    errorMessage.classList.remove("hidden");
    numOfPeopleInput.classList.add("border-error");
  } else if (peopleChoice >= 1) {
    errorMessage.classList.add("hidden");
    numOfPeopleInput.classList.remove("border-error");
  }

  const totalAmountwithtip = parseFloat((amountChoice * tipChoice).toFixed(2));

  const totalNumberOfPeopleBill = (
    (amount + totalAmountwithtip) /
    peopleChoice
  ).toFixed(2);

  //display value in tip Amount
  tipAmount.innerHTML = `$${totalAmountwithtip}`;

  //display total person pay
  personTotal.innerHTML = `$${
    typeof parseInt(totalNumberOfPeopleBill) === Infinity
      ? ""
      : totalNumberOfPeopleBill
  }`;

  //Remove active class
  tipBtn.forEach((item) => item.classList.remove("active"));
  resetBtn.removeAttribute("disabled");

  //Add active class
  clicked.classList.add("active");
});

///////////////////////////////////

//remove active class on input click
billInput.addEventListener("click", function (e) {
  billInput.classList.add("border-cyan");
  tipBtn.forEach((item) => item.classList.remove("active"));
});
numOfPeopleInput.addEventListener("click", function (e) {
  tipBtn.forEach((item) => item.classList.remove("active"));
  errorMessage.classList.add("hidden");
  numOfPeopleInput.classList.remove("border-error");
  numOfPeopleInput.classList.add("border-cyan");
});

////////////////////////////////////////////////////////
//Reset Button
btnContainer.addEventListener("click", function (e) {
  e.preventDefault();

  billInput.value = "";
  numOfPeopleInput.value = "";
  customBtn.value = "";
  tipAmount.innerHTML = 0.0;
  personTotal.innerHTML = 0.0;
  tipBtn.forEach((item) => item.classList.remove("active"));
  resetBtn.setAttribute("disabled", "true");
  errorMessage.classList.add("hidden");
  numOfPeopleInput.classList.remove("border-error");
  numOfPeopleInput.classList.remove("border-cyan");
  billInput.classList.remove("border-cyan");
});
